import { render, staticRenderFns } from "./BlockRendererTemplates.vue?vue&type=template&id=1351e5c0"
import script from "./BlockRendererTemplates.vue?vue&type=script&lang=js"
export * from "./BlockRendererTemplates.vue?vue&type=script&lang=js"
import style0 from "./BlockRendererTemplates.vue?vue&type=style&index=0&id=1351e5c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports